import BannerOne from "../assets/WhatsApp Image 2024-03-09 at 5.23.32 PM.jpeg";
import BannerTwo from "../assets/WhatsApp Image 2024-03-09 at 5.23.30 PM.jpeg";
import BannerThree from "../assets/WhatsApp Image 2024-03-09 at 5.23.32 PM (1).jpeg";
import villasmap from "../assets/raheemvillas.jpeg";
import citymap from "../assets/raheemcity.jpeg";
import paradisemap from "../assets/smartcity.PNG";
import housingmap from "../assets/alraheemhosuing.jpeg";
import homesmap from "../assets/rahimHomes.PNG";
// import housingmap from "../assets/map1.jpg";
import RahimTownImg1 from "../assets/IMG_7733 copy.jpg";
import RahimTownImg2 from "../assets/dji_export_1642089789775.00_08_47_28.Still012 copy.jpg";
import RahimTownImg3 from "../assets/IMG_7464 copy.jpg";
import RahimTownImg4 from "../assets/IMG_7431 copy.jpg";
import RahimTownImg5 from "../assets/IMG_7506 copy.jpg";
// villa
import RahimVillaImg1 from "../assets/dji_export_1642089789775.00_08_09_01.Still011 copy.jpg";
import RahimVillaImg2 from "../assets/dji_export_1642089789775.00_14_25_09.Still021 copy.jpg";
import RahimVillaImg3 from "../assets/dji_export_1642089789775.00_07_32_03.Still009 copy.jpg";
import RahimVillaImg4 from "../assets/dji_export_1642089789775.00_03_45_25.Still006 copy.jpg";
import RahimVillaImg5 from "../assets/dji_export_1642089789775.00_02_55_00.Still005 copy.jpg";
// Rahim city
import RahimCityImg1 from "../assets/IMG_6863 copy.jpg";
import RahimCityImg2 from "../assets/IMG_6870 copy.jpg";
import RahimCityImg3 from "../assets/IMG_6878 copy.jpg";
import RahimCityImg4 from "../assets/IMG_6951 copy.jpg";
import RahimCityImg5 from "../assets/IMG_7004 copy.jpg";
// rahim paradise
import RahimparadiseImg1 from "../assets/IMG_6974 copy.jpg";
import RahimparadiseImg2 from "../assets/IMG_6978 copy.jpg";
import RahimparadiseImg3 from "../assets/IMG_6999 copy.jpg";
import RahimparadiseImg4 from "../assets/IMG_6961 copy.jpg";
import RahimparadiseImg5 from "../assets/IMG_6883 copy.jpg";
// rahim housing scheme
import RahimphousingschemeImg1 from "../assets/VIEW 2.jpg";
import RahimphousingschemeImg2 from "../assets/VIEW 3.jpg";
import RahimphousingschemeImg3 from "../assets/VIEW 4.jpg";
import RahimphousingschemeImg4 from "../assets/VIEW 6.jpg";
import RahimphousingschemeImg5 from "../assets/VIEW 9.jpg";
// commercial markete
import RahimcommercialImg4 from "../assets/VIEW 5.jpg";
import RahimcommercialImg5 from "../assets/VIEW 8.jpg";
import CommercialMap from "../assets/commercialmap.PNG";
//
import ProjectImg1 from "../assets/WhatsApp Image 2024-03-09 at 5.23.30 PM.jpeg";
import ProjectImg2 from "../assets/WhatsApp Image 2024-03-09 at 5.23.31 PM.jpeg";
import ProjectImg3 from "../assets/WhatsApp Image 2024-03-09 at 5.23.28 PM.jpeg";
import ProjectImg4 from "../assets/WhatsApp Image 2024-03-09 at 5.23.27 PM (1).jpeg";
import ProjectImg5 from "../assets/WhatsApp Image 2024-03-09 at 5.23.21 PM (1).jpeg";
import ProjectImg6 from "../assets/WhatsApp Image 2024-03-09 at 5.23.23 PM.jpeg";
import ProjectImg7 from "../assets/WhatsApp Image 2024-03-09 at 5.23.22 PM (1).jpeg";
import ProjectImg8 from "../assets/WhatsApp Image 2024-03-09 at 5.23.32 PM (1).jpeg";
import ProjectImg9 from "../assets/WhatsApp Image 2024-03-09 at 5.23.29 PM.jpeg";

import PressImg from "../assets/pexels-johannes-plenio-1103970.jpg";
import PressImg2 from "../assets/pexels-nick-collins-1293120.jpg";
import MapIcon from "../assets/location.png";
// possession forms
 import housingPossession from "./Posession Form housing scheme-2.pdf";
 import smartPossession from "./Posession Form housing scheme-3.pdf";
 import paradisePossession from "./Posession Form housing scheme-4.pdf"

export const HomeBanners = [
  {
    id: 1,
    image: BannerOne,
  },
  {
    id: 2,
    image: BannerTwo,
  },
  {
    id: 3,
    image: BannerThree,
  },
  {
    id: 4,
    image: RahimcommercialImg4,
  },
  {
    id: 5,
    image: RahimcommercialImg5,
  },
  {
    id: 6,
    image: RahimphousingschemeImg5,
  },
];

export const MissionVision = [
  {
    id: 1,
    title: "Mission",
    desc: " Hussain Developers Will achive life long customer satisfaction by delivering properties at locations of their choices,meeting or exceeding their needs and expectations in a timely cost-effective and value added manner.",
    image: BannerOne,
  },
  {
    id: 2,
    title: "Vision",
    desc: "Hussain Developers will be the leader in providing luxurious lifestyle, world class amenities and gold standard living through strong customer focus, innovative ideas, superior development standards and relentless attainment of objectives by empowered people.",
    image: BannerTwo,
  },
];

export const AwardList = [
  {
    id: 1,
    desc: "Hussain Developer WON 10 Prestigious Awards",
  },
  {
    id: 2,
    desc: "Asia Pacific International Property Awards, Kuala Lumpur, Malaysia",
  },
  {
    id: 3,
    desc: "Highly Commended Leisure Interior",
  },
  {
    id: 4,
    desc: "Best 5-Star Golf Development",
  },
  {
    id: 5,
    desc: "Best 5-Star Leisure Architecture",
  },
  {
    id: 6,
    desc: "Highly Commended Hi-Rise Architecture",
  },
  {
    id: 7,
    desc: "Highly Commended Retail Interior",
  },
  {
    id: 8,
    desc: "Higly Commended Leisure Interior",
  },
];

export const ExclusiveList = [
  {
    id: 1,
    desc: "6 kanal Grand Mosque",
  },
  {
    id: 2,
    desc: "Bahawalpur Biggest Housing Scheme",
  },
  {
    id: 3,
    desc: "25 kanal central park",
  },
  {
    id: 4,
    desc: "100 feet main bolivard",
  },
  {
    id: 5,
    desc: "Gold Class Cinema",
  },
  {
    id: 6,
    desc: "International level school",
  },
  {
    id: 7,
    desc: "Cash & Carry Super Markit",
  },
  {
    id: 8,
    desc: "Hospital",
  },
  {
    id: 9,
    desc: "Bank",
  },
  {
    id: 10,
    desc: "Mini Zoo",
  },
  {
    id: 11,
    desc: "24/7 CCTV Surveillance",
  },
];

export const LocalOffices = [
  {
    city: "Bahawal Pur",
    address:
      "Hussain developers & builders Jhangi Wala Road Opposite Sir Sadiq Hospital Bahawalpur beside Attock Petrolliuem Service.",
    phone: "0304-1111490",
    mobile: "0304-1111490",
  },
];

export const TownMapsAll = [
  {
    id: "1",
    title: "Al Rahim Town Map",
    img: villasmap,
    icon: MapIcon,
    town: "Al Rahim Town",
    city: "Bahawal Pur",
    desc: "Al Rahim Town Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "2",
    title: "Al Rahim Villas Map",
    img: villasmap,
    icon: MapIcon,
    town: "Al Rahim Villas",
    city: "Bahawal Pur",
    desc: "Al Rahim Villas Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "3",
    title: "Al Rahim City Map",
    img: citymap,
    icon: MapIcon,
    town: "Al Rahim City",
    city: "Bahawal Pur",
    desc: "Al Rahim City Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "4",
    title: "Al Rahim Paradise Map",
    img: citymap,
    icon: MapIcon,
    town: "Al Rahim Paradise",
    city: "Bahawal Pur",
    desc: "Al Rahim Paradise Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "5",
    title: "Al Rahim Housing Scheme Map",
    img: housingmap,
    icon: MapIcon,
    town: "Al Rahim Housing Scheme",
    city: "Bahawal Pur",
    desc: "Al Rahim Housing Scheme Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "6",
    title: "Al Rahim Homes Housing Scheme Map",
    img: homesmap,
    icon: MapIcon,
    town: "Al Rahim Homes Housing Scheme",
    city: "Bahawal Pur",
    desc: "Al Rahim Homes Housing Scheme Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "7",
    title: "Al Rahim Smart City Map",
    img: paradisemap,
    icon: MapIcon,
    town: "Al Rahim Smart City",
    city: "Bahawal Pur",
    desc: "Al Rahim Smart City Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "8",
    title: "Al Rahim Commercial Markete Map",
    img: CommercialMap,
    icon: MapIcon,
    town: "Al Rahim Commercial Markete",
    city: "Bahawal Pur",
    desc: "Al Rahim Commercial Markete Bahawalpur Map With All features And Latest Development.",
  },
];

export const AllPossessionForms = [
  {
    id: "1",
    title: "Al Rahim Homes Housing Scheme",
    img: housingmap,
    icon: MapIcon,
    town: "Al Rahim Homes Housing Scheme",
    city: "Bahawal Pur",
    form:housingPossession,
    desc: "Al Rahim Homes Housing Scheme Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "2",
    title: "Al Rahim Paradise",
    img: housingmap,
    icon: MapIcon,
    form:paradisePossession,
    town: "Iqbal Town",
    city: "Bahawal Pur",
    desc: "Iqbal Town Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "3",
    title: "Al Rahim Housing Scheme",
    img: housingmap,
    icon: MapIcon,
    form:housingPossession,
    town: "Raheem Town",
    city: "Bahawal Pur",
    desc: "Raheem Town Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "4",
    title: "Al Rahim Smart City",
    img: housingmap,
    icon: MapIcon,
    form:smartPossession,
    town: "Al Rahim Smart City",
    city: "Bahawal Pur",
    desc: "Aviccena Town Bahawalpur Map With All features And Latest Development.",
  },
];

export const AllSampleForms = [
  {
    id: "1",
    title: "Al Rahim Homes Housing Scheme",
    img: housingmap,
    icon: MapIcon,
    town: "Zaheer Town",
    form:housingPossession,
    city: "Bahawal Pur",
    desc: "Zaheer Town Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "2",
    title: "Al Rahim Paradise",
    img: housingmap,
    icon: MapIcon,
    form:paradisePossession,
    town: "Iqbal Town",
    city: "Bahawal Pur",
    desc: "Iqbal Town Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "3",
    title: "Al Rahim Housing Scheme",
    img: housingmap,
    icon: MapIcon,
    form:housingPossession,
    town: "Raheem Town",
    city: "Bahawal Pur",
    desc: "Raheem Town Bahawalpur Map With All features And Latest Development.",
  },
  {
    id: "4",
    title: "Al Rahim Smart City",
    img: housingmap,
    icon: MapIcon,
    form:smartPossession,
    town: "Aviccena Town",
    city: "Bahawal Pur",
    desc: "Aviccena Town Bahawalpur Map With All features And Latest Development.",
  },
];

export const AllProjects = [
  {
    id: "1",
    title: "Al Rahim Town",
    img: ProjectImg1,
    icon: MapIcon,
    map: villasmap,
    gallery: [
      {
        id: 1,
        image: RahimTownImg1,
      },
      {
        id: 2,
        image: RahimTownImg2,
      },
      {
        id: 3,
        image: RahimTownImg3,
      },
      {
        id: 4,
        image: RahimTownImg4,
      },
      {
        id: 5,
        image: RahimTownImg5,
      },
    ],
    town: "Al Rahim Town",
    city: "Bahawal Pur",
    construction:
      "The construction work in Al Rahim Town is in full pace. The managment claims to complete this project in the upcoming year. So, book your plot now with Hussain Developer as the current prices are on pre-launch basis.",
    facilities: [
      {
        text: "Underground Electricity",
      },
      {
        text: "Gas",
      },
      {
        text: "Bank",
      },
      {
        text: "Hospital",
      },
      {
        text: "School",
      },
      {
        text: "Cash & Carry",
      },
      {
        text: "Parks",
      },
      {
        text: "Mosque",
      },
      {
        text: "Carpet Roads",
      },
      {
        text: "24/7 Security",
      },
      {
        text: "Community Building",
      },
      {
        text: "Commercial Area",
      },
      {
        text: "Gold Class Cinema",
      },
      {
        text: "Zoo",
      },
      {
        text: "Fountains",
      },
      {
        text: "Theme Park",
      },
    ],
    paymentplan: "Rate Rs 600,000 per marla Total Net Cash.",
    location: "Al Rahim Town Jhangi wala Road Bahawalpur.",
    desc: "Al Rahim Town Bahawalpur Map With All features And Latest Development.",
    overview:
      "The real estate industry, despite being highly expensive, provides rare community-building & urban living infrastructures in Pakistan. A considerable number of property developers sell only cemented infrastructures in the name of modern housing projects. You are pretty aware of the increase in property prices with no end in sight.Hussain Developer has started rendering its services because of the ethical provision of real estate facilities & amenities according to the charged property rates.Al Rahim Town offers 3 Marla Plots, 5 Marla Urban Terraces Homes, and 2 Marla Commercial Plots in its beautiful enclave situated at an attractive geographical location.",
  },
  {
    id: "2",
    title: "Al Rahim Villas",
    gallery: [
      {
        id: 1,
        image: RahimVillaImg1,
      },
      {
        id: 2,
        image: RahimVillaImg2,
      },
      {
        id: 3,
        image: RahimVillaImg3,
      },
      {
        id: 4,
        image: RahimVillaImg4,
      },
      {
        id: 5,
        image: RahimVillaImg5,
      },
    ],
    img: ProjectImg2,
    icon: MapIcon,
    map: villasmap,
    town: "Al Rahim Villas",
    city: "Bahawal Pur",
    construction:
      "The construction work in Urban Enclave is in full pace. The managment claims to complete this project in the upcoming year. So, book your plot now with Apex Group as the current prices are on pre-launch basis.",
    facilities: [
      {
        text: "Underground Electricity",
      },
      {
        text: "Gas",
      },
      {
        text: "Bank",
      },
      {
        text: "Hospital",
      },
      {
        text: "School",
      },
      {
        text: "Cash & Carry",
      },
      {
        text: "Parks",
      },
      {
        text: "Mosque",
      },
      {
        text: "Carpet Roads",
      },
      {
        text: "24/7 Security",
      },
      {
        text: "Community Building",
      },
      {
        text: "Commercial Area",
      },
      {
        text: "Gold Class Cinema",
      },
      {
        text: "Zoo",
      },
      {
        text: "Fountains",
      },
      {
        text: "Theme Park",
      },
    ],
    paymentplan: "Rate Rs 600,000 per marla Total Net Cash.",
    desc: "Al Rahim Villas Bahawalpur Map With All features And Latest Development.",
    location: "Al Rahim Villas Jhangi wala Road Bahawlapur.",
    overview:
      "The real estate industry, despite being highly expensive, provides rare community-building & urban living infrastructures in Pakistan. A considerable number of property developers sell only cemented infrastructures in the name of modern housing projects. You are pretty aware of the increase in property prices with no end in sight.Hussain Developer has started rendering its services because of the ethical provision of real estate facilities & amenities according to the charged property rates. Al Rahim Villas offers 3 Marla Plots, 5 Marla Urban Terraces Homes, and 2 Marla Commercial Plots in its beautiful enclave situated at an attractive geographical location.",
  },
  {
    id: "3",
    title: "Al Rahim City",
    gallery: [
      {
        id: 1,
        image: RahimCityImg1,
      },
      {
        id: 2,
        image: RahimCityImg2,
      },
      {
        id: 3,
        image: RahimCityImg3,
      },
      {
        id: 4,
        image: RahimCityImg4,
      },
      {
        id: 5,
        image: RahimCityImg5,
      },
    ],
    img: ProjectImg3,
    icon: MapIcon,
    map: citymap,
    town: "Al Rahim City",
    city: "Bahawal Pur",
    construction:
      "The construction work in Urban Enclave is in full pace. The managment claims to complete this project in the upcoming year. So, book your plot now with Apex Group as the current prices are on pre-launch basis.",
    facilities: [
      {
        text: "Underground Electricity",
      },
      {
        text: "Gas",
      },
      {
        text: "Bank",
      },
      {
        text: "Hospital",
      },
      {
        text: "School",
      },
      {
        text: "Cash & Carry",
      },
      {
        text: "Parks",
      },
      {
        text: "Mosque",
      },
      {
        text: "Carpet Roads",
      },
      {
        text: "24/7 Security",
      },
      {
        text: "Community Building",
      },
      {
        text: "Commercial Area",
      },
      {
        text: "Gold Class Cinema",
      },
      {
        text: "Zoo",
      },
      {
        text: "Fountains",
      },
      {
        text: "Theme Park",
      },
    ],
    paymentplan: "Rate RS 800,000 per marla Total Net Cash.",
    desc: "Al Rahim City Bahawalpur Map With All features And Latest Development.",
    location:
      "Al Rahim Paradise & City Jhangi Wala Road Near Drug Laboratory Opposite Al Haram Town Bahawalpur.",
    overview:
      "The real estate industry, despite being highly expensive, provides rare community-building & urban living infrastructures in Pakistan. A considerable number of property developers sell only cemented infrastructures in the name of modern housing projects. You are pretty aware of the increase in property prices with no end in sight.Hussain Developer has started rendering its services because of the ethical provision of real estate facilities & amenities according to the charged property rates. Al Rahim City offers 3 Marla Plots, 5 Marla Urban Terraces Homes, and 2 Marla Commercial Plots in its beautiful enclave situated at an attractive geographical location.",
  },
  {
    id: "4",
    title: "Al Rahim Paradise",
    gallery: [
      {
        id: 1,
        image: RahimparadiseImg1,
      },
      {
        id: 2,
        image: RahimparadiseImg2,
      },
      {
        id: 3,
        image: RahimparadiseImg3,
      },
      {
        id: 4,
        image: RahimparadiseImg4,
      },
      {
        id: 5,
        image: RahimparadiseImg5,
      },
    ],
    img: ProjectImg4,
    icon: MapIcon,
    map: citymap,
    town: "Al Rahim Paradise",
    city: "Bahawal Pur",
    construction:
      "The construction work in Urban Enclave is in full pace. The managment claims to complete this project in the upcoming year. So, book your plot now with Apex Group as the current prices are on pre-launch basis.",
    facilities: [
      {
        text: "Underground Electricity",
      },
      {
        text: "Gas",
      },
      {
        text: "Bank",
      },
      {
        text: "Hospital",
      },
      {
        text: "School",
      },
      {
        text: "Cash & Carry",
      },
      {
        text: "Parks",
      },
      {
        text: "Mosque",
      },
      {
        text: "Carpet Roads",
      },
      {
        text: "24/7 Security",
      },
      {
        text: "Community Building",
      },
      {
        text: "Commercial Area",
      },
      {
        text: "Gold Class Cinema",
      },
      {
        text: "Zoo",
      },
      {
        text: "Fountains",
      },
      {
        text: "Theme Park",
      },
    ],
    paymentplan: "Rate RS 800,000 per marla Total Net Cash.",
    location:
      "Jhangi Wala Road Near Drug Laboratory oppositet Al Haram Town Bahawalpur.",
    overview:
      "The real estate industry, despite being highly expensive, provides rare community-building & urban living infrastructures in Pakistan. A considerable number of property developers sell only cemented infrastructures in the name of modern housing projects. You are pretty aware of the increase in property prices with no end in sight.Hussain Developer has started rendering its services because of the ethical provision of real estate facilities & amenities according to the charged property rates. Urban Enclave offers 3 Marla Plots, 5 Marla Urban Terraces Homes, and 2 Marla Commercial Plots in its beautiful enclave situated at an attractive geographical location.",
    desc: "Al Rahim Paradise Bahawalpur Map With All features And Latest Development.",
    paymentplan5:
      "5 Marla Urban Terraces Homes have unique interior and exterior designs, offering you a chance to live up to life. These terrace homes are being built on a beautiful landscape surrounding eco-friendly structures and green spaces.At a pre-launch price, the 5 Marla Terrace Home has a total price of 7,000,000 PKR. You need to pay 1,050,000 PKR as a down payment, 1,050,000 PKR balloting amount after 45 days, 30 monthly installments of 70,000 PKR, 350,000 PKR DP (1st, 2nd, 3rd Lenter), and 1,750,000 PKR amount during the possession of your plot. Contact Apex Properties to book your favorite plot.",
    paymentplan3:
      "There are multiple 3 Marla Residential Plots in Urban Enclave dimensions of 18’-0 × 37’-6. The general people who are looking for societies- providing urban living- have an opportunity to invest in Urban Enclave. There is a flexible payment plan for 3 Marla Plots.A 3-Marla Plot has a total price of 36 Lac at a pre-launch price. You need to pay a 1,080,000 as a down payment, 24 monthly installments of 45,000 PKR, 3 bi-annual payments of 180,000 PKR, and 900,000 PKR during the possession of your plot. Contact Apex Properties to book your favorite plot.",
  },
  {
    id: "5",
    title: "Al Rahim Housing Scheme",
    img: ProjectImg5,
    icon: MapIcon,
    town: "Al Rahim Housing Scheme",
    city: "Bahawal Pur",
    gallery: [
      {
        id: 1,
        image: RahimphousingschemeImg1,
      },
      {
        id: 2,
        image: RahimphousingschemeImg2,
      },
      {
        id: 3,
        image: RahimphousingschemeImg3,
      },
      {
        id: 4,
        image: RahimphousingschemeImg4,
      },
      {
        id: 5,
        image: RahimphousingschemeImg5,
      },
    ],
    map: housingmap,
    construction:
      "The construction work in Urban Enclave is in full pace. The managment claims to complete this project in the upcoming year. So, book your plot now with Apex Group as the current prices are on pre-launch basis.",
    facilities: [
      {
        text: "Underground Electricity",
      },
      {
        text: "Gas",
      },
      {
        text: "Bank",
      },
      {
        text: "Hospital",
      },
      {
        text: "School",
      },
      {
        text: "Cash & Carry",
      },
      {
        text: "Parks",
      },
      {
        text: "Mosque",
      },
      {
        text: "Carpet Roads",
      },
      {
        text: "24/7 Security",
      },
      {
        text: "Community Building",
      },
      {
        text: "Commercial Area",
      },
      {
        text: "Gold Class Cinema",
      },
      {
        text: "Zoo",
      },
      {
        text: "Fountains",
      },
      {
        text: "Theme Park",
      },
    ],
    paymentplan:
      "A Block Rate 625000 per marla 30% Advance 2.5 Years of installment.",
    paymentplanB:
      "B Block Rate 575000 per marla 30% Advance 2.5 Years of installment.",
    paymentplanC:
      " C Block Rate 500000 per marla 30% Advance 2.5 Years of installment",
    paymntplanD:
      "D Block Rate 450000 per marla 30% Advance 2.5 Years of installment",

    paymentplan3:
      "There are multiple 3 Marla Residential Plots in Urban Enclave dimensions of 18’-0 × 37’-6. The general people who are looking for societies- providing urban living- have an opportunity to invest in Urban Enclave. There is a flexible payment plan for 3 Marla Plots.A 3-Marla Plot has a total price of 36 Lac at a pre-launch price. You need to pay a 1,080,000 as a down payment, 24 monthly installments of 45,000 PKR, 3 bi-annual payments of 180,000 PKR, and 900,000 PKR during the possession of your plot. Contact Apex Properties to book your favorite plot.",
    desc: "Al Rahim Housing Scheme Bahawalpur Map With All features And Latest Development.",
    overview:
      "The real estate industry, despite being highly expensive, provides rare community-building & urban living infrastructures in Pakistan. A considerable number of property developers sell only cemented infrastructures in the name of modern housing projects. You are pretty aware of the increase in property prices with no end in sight.Hussain Developer has started rendering its services because of the ethical provision of real estate facilities & amenities according to the charged property rates. Al Rahim Homes offers 3 Marla Plots, 5 Marla Urban Terraces Homes, and 2 Marla Commercial Plots in its beautiful enclave situated at an attractive geographical location.",
    location:
      "Al Rahim Housing Scheme Hasilpur road Near Govt Employees Housing Scheme Bahawalpur.",
  },
  {
    id: "6",
    title: "Al Rahim Homes Housing Scheme",
    img: ProjectImg6,
    icon: MapIcon,
    gallery: [
      {
        id: 1,
        image: ProjectImg1,
      },
      {
        id: 2,
        image: ProjectImg2,
      },
      {
        id: 3,
        image: ProjectImg3,
      },
      {
        id: 4,
        image: ProjectImg4,
      },
      {
        id: 5,
        image: ProjectImg5,
      },
    ],
    town: "Al Rahim Homes Housing Scheme",
    city: "Bahawal Pur",
    map: homesmap,
    construction:
      "The construction work in Urban Enclave is in full pace. The managment claims to complete this project in the upcoming year. So, book your plot now with Apex Group as the current prices are on pre-launch basis.",
    facilities: [
      {
        text: "Underground Electricity",
      },
      {
        text: "Gas",
      },
      {
        text: "Bank",
      },
      {
        text: "Hospital",
      },
      {
        text: "School",
      },
      {
        text: "Cash & Carry",
      },
      {
        text: "Parks",
      },
      {
        text: "Mosque",
      },
      {
        text: "Carpet Roads",
      },
      {
        text: "24/7 Security",
      },
      {
        text: "Community Building",
      },
      {
        text: "Commercial Area",
      },
      {
        text: "Gold Class Cinema",
      },
      {
        text: "Zoo",
      },
      {
        text: "Fountains",
      },
      {
        text: "Theme Park",
      },
    ],
    paymentplan:
      "Rate RS 800,000 per marla,Advance 30% and 2 years of Installement time",
    paymentplan3:
      "There are multiple 3 Marla Residential Plots in Urban Enclave dimensions of 18’-0 × 37’-6. The general people who are looking for societies- providing urban living- have an opportunity to invest in Urban Enclave. There is a flexible payment plan for 3 Marla Plots.A 3-Marla Plot has a total price of 36 Lac at a pre-launch price. You need to pay a 1,080,000 as a down payment, 24 monthly installments of 45,000 PKR, 3 bi-annual payments of 180,000 PKR, and 900,000 PKR during the possession of your plot. Contact Apex Properties to book your favorite plot.",
    desc: "Al Rahim Homes Housing Scheme Bahawalpur Map With All features And Latest Development.",
    overview:
      "The real estate industry, despite being highly expensive, provides rare community-building & urban living infrastructures in Pakistan. A considerable number of property developers sell only cemented infrastructures in the name of modern housing projects. You are pretty aware of the increase in property prices with no end in sight.Hussain Developer has started rendering its services because of the ethical provision of real estate facilities & amenities according to the charged property rates. Urban Enclave offers 3 Marla Plots, 5 Marla Urban Terraces Homes, and 2 Marla Commercial Plots in its beautiful enclave situated at an attractive geographical location.",
    location:
      "Al Rahim Homes Jhangi wala road behind Sir Sadig Hospital Bahawal Pur",
  },
  {
    id: "7",
    title: "Al Rahim Smart City",
    img: RahimphousingschemeImg2,
    icon: MapIcon,
    town: "Al Rahim Smart City",
    city: "Bahawal Pur",
    map: paradisemap,
    gallery: [
      {
        id: 1,
        image: RahimphousingschemeImg5,
      },
      {
        id: 2,
        image: RahimphousingschemeImg3,
      },
      {
        id: 3,
        image: RahimcommercialImg4,
      },
      {
        id: 4,
        image: RahimcommercialImg5,
      },
      {
        id: 5,
        image: ProjectImg5,
      },
    ],
    construction:
      "The construction work in Al Rahim Smart City is in full pace. The managment claims to complete this project in the upcoming year. So, book your plot now with Apex Group as the current prices are on pre-launch basis.",
    facilities: [
      {
        text: "Underground Electricity",
      },
      {
        text: "Gas",
      },
      {
        text: "Bank",
      },
      {
        text: "Hospital",
      },
      {
        text: "School",
      },
      {
        text: "Cash & Carry",
      },
      {
        text: "Parks",
      },
      {
        text: "Mosque",
      },
      {
        text: "Carpet Roads",
      },
      {
        text: "24/7 Security",
      },
      {
        text: "Community Building",
      },
      {
        text: "Commercial Area",
      },
      {
        text: "Gold Class Cinema",
      },
      {
        text: "Zoo",
      },
      {
        text: "Fountains",
      },
      {
        text: "Theme Park",
      },
    ],
    paymentplan:
      "Rate Rs 700,000 and Advance is 25% for 3 Years of Installment Time.",
    paymentplan3:
      "There are multiple 3 Marla Residential Plots in Al Rahim Smart City dimensions of 18’-0 × 37’-6. The general people who are looking for societies- providing urban living- have an opportunity to invest in Urban Enclave. There is a flexible payment plan for 3 Marla Plots.A 3-Marla Plot has a total price of 36 Lac at a pre-launch price. You need to pay a 1,080,000 as a down payment, 24 monthly installments of 45,000 PKR, 3 bi-annual payments of 180,000 PKR, and 900,000 PKR during the possession of your plot. Contact Apex Properties to book your favorite plot.",
    desc: "Al Rahim Smart City Bahawalpur Map With All features And Latest Development.",
    location:
      "Al Rahim Smat City Jhangi wala Road Behind sir sadiq hospital Bahawalpur.",
    overview:
      "The real estate industry, despite being highly expensive, provides rare community-building & urban living infrastructures in Pakistan. A considerable number of property developers sell only cemented infrastructures in the name of modern housing projects. You are pretty aware of the increase in property prices with no end in sight.Hussain Developer has started rendering its services because of the ethical provision of real estate facilities & amenities according to the charged property rates. Al Rahim Smart City offers 3 Marla Plots, 5 Marla Urban Terraces Homes, and 2 Marla Commercial Plots in its beautiful enclave situated at an attractive geographical location.",
  },
  {
    id: "8",
    title: "Al Rahim Commercial Markete",
    img: RahimcommercialImg4,
    icon: MapIcon,
    town: "Al Rahim Commercial Markete",
    city: "Bahawal Pur",
    gallery: [
      {
        id: 1,
        image: RahimcommercialImg4,
      },
      {
        id: 2,
        image: RahimcommercialImg5,
      },
      {
        id: 3,
        image: ProjectImg3,
      },
      {
        id: 4,
        image: ProjectImg4,
      },
      {
        id: 5,
        image: ProjectImg5,
      },
    ],
    map: CommercialMap,
    construction:
      "The construction work in Al Rahim Commercial Markete is in full pace. The managment claims to complete this project in the upcoming year. So, book your plot now with Apex Group as the current prices are on pre-launch basis.",
    facilities: [
      {
        text: "Underground Electricity",
      },
      {
        text: "Gas",
      },
      {
        text: "Bank",
      },
      {
        text: "Hospital",
      },
      {
        text: "School",
      },
      {
        text: "Cash & Carry",
      },
      {
        text: "Parks",
      },
      {
        text: "Mosque",
      },
      {
        text: "Carpet Roads",
      },
      {
        text: "24/7 Security",
      },
      {
        text: "Community Building",
      },
      {
        text: "Commercial Area",
      },
      {
        text: "Gold Class Cinema",
      },
      {
        text: "Zoo",
      },
      {
        text: "Fountains",
      },
      {
        text: "Theme Park",
      },
    ],
    paymentplan:
      "Rate Rs 1850,000 per marla 25% Advance 3 Years of Installment time.",
    paymentplan3:
      "There are multiple 3 Marla Residential Plots in Urban Enclave dimensions of 18’-0 × 37’-6. The general people who are looking for societies- providing urban living- have an opportunity to invest in Al Rahim Commercial Markete. There is a flexible payment plan for 3 Marla Plots.A 3-Marla Plot has a total price of 36 Lac at a pre-launch price. You need to pay a 1,080,000 as a down payment, 24 monthly installments of 45,000 PKR, 3 bi-annual payments of 180,000 PKR, and 900,000 PKR during the possession of your plot. Contact Apex Properties to book your favorite plot.",
    desc: "Al Rahim Commercial Markete Bahawalpur Map With All features And Latest Development.",
    overview:
      "The real estate industry, despite being highly expensive, provides rare community-building & urban living infrastructures in Pakistan. A considerable number of property developers sell only cemented infrastructures in the name of modern housing projects. You are pretty aware of the increase in property prices with no end in sight.Hussain Developer has started rendering its services because of the ethical provision of real estate facilities & amenities according to the charged property rates. Al Rahim Commercial Markete offers 3 Marla Plots, 5 Marla Urban Terraces Homes, and 2 Marla Commercial Plots in its beautiful enclave situated at an attractive geographical location.",
    location:
      "Al Rahim Commercial Markete Northern Bypass Near Salanh Chowk Bahawalpur.",
  },
];

export const PressReleases = [
  {
    id: "1",
    img: PressImg,
    title:
      "Hussain developer DISTRIBUTES 250 RATION BAGS AMONG RICKSHAW DRIVERS OF KARACHI",
    date: "2 Oct 2023",
    detail:
      "Hussain Developer – Hussain Developer Bahawal Pur is the only private real estate sector that has introduced the Synthetic Natural Gas (SNG) plant, marking a significant leap forward in sustainable gas supply solutions in the face of energy crisis. The pioneering SNG plant, with a capacity of 70 MMBTU/HR, is set to provide uninterrupted gas supply to thousands of households scaling up to accommodate the needs of up to 10,000 houses in the initial phase.Amid the prevailing challenges of gas shortages faced by Pakistan, Hussain Developer Bahawal Pur’s SNG plant takes center stage as a beacon of innovation and reliability in gas distribution. The United States-originated SNG plant is strategically interconnected with an extensive gas network spanning approximately 650 km across Hussain Developer’s vicinity. This strategic integration ensures the seamless delivery of safe, reliable, and efficient SNG supply to the residents of Hussain Developer Bahawal Pur.Adhering meticulously to international standards and regulations, the SNG plant demonstrates full compliance with the regulations set forth by the Oil and Gas Regulatory Authority (OGRA), National Fire Protection Association (NFPA), American Petroleum Institute (API), American Gas Association (AGA), American Society for Testing and Materials (ASTM), and American Society of Mechanical Engineers (ASME). These stringent measures underscore Hussain Developer Bahawal Pur’s unwavering commitment to maintaining the highest standards of safety, quality, and operational excellence.    “This achievement marks the first milestone in our journey to provide reliable gas supply to Hussain Developer Bahawal Pur,” stated Spokesperson of Hussain Developer Bahawal Pur. “We are dedicated to pioneering solutions that alleviate the challenges posed by gas shortages in Pakistan. This SNG plant showcases our dedication to sustainable infrastructure development and serves as a testament to our commitment to the well-being of our community.”The launch of the SNG plant underscores Hussain Developer Bahawal Pur’s dedication to innovation, sustainability, and the welfare of its residents. As the first step in a series of transformative advancements, Hussain Developer Bahawal Pur reaffirms its position as an industry leader in addressing critical energy needs and enhancing the quality of life for its residents.",
    desc: "Press Release Hussain Developer distributes 250 ration bags among rickshaw drivers of Bahawal Pur...",
  },
  {
    id: "2",
    img: PressImg2,
    detail:
      "Hussain Developer – Hussain Developer Bahawal Pur is the only private real estate sector that has introduced the Synthetic Natural Gas (SNG) plant, marking a significant leap forward in sustainable gas supply solutions in the face of energy crisis. The pioneering SNG plant, with a capacity of 70 MMBTU/HR, is set to provide uninterrupted gas supply to thousands of households scaling up to accommodate the needs of up to 10,000 houses in the initial phase.Amid the prevailing challenges of gas shortages faced by Pakistan, Hussain Developer Bahawal Pur’s SNG plant takes center stage as a beacon of innovation and reliability in gas distribution. The United States-originated SNG plant is strategically interconnected with an extensive gas network spanning approximately 650 km across Hussain Developer’s vicinity. This strategic integration ensures the seamless delivery of safe, reliable, and efficient SNG supply to the residents of Hussain Developer Bahawal Pur.Adhering meticulously to international standards and regulations, the SNG plant demonstrates full compliance with the regulations set forth by the Oil and Gas Regulatory Authority (OGRA), National Fire Protection Association (NFPA), American Petroleum Institute (API), American Gas Association (AGA), American Society for Testing and Materials (ASTM), and American Society of Mechanical Engineers (ASME). These stringent measures underscore Hussain Developer Bahawal Pur’s unwavering commitment to maintaining the highest standards of safety, quality, and operational excellence.    “This achievement marks the first milestone in our journey to provide reliable gas supply to Hussain Developer Bahawal Pur,” stated Spokesperson of Hussain Developer Bahawal Pur. “We are dedicated to pioneering solutions that alleviate the challenges posed by gas shortages in Pakistan. This SNG plant showcases our dedication to sustainable infrastructure development and serves as a testament to our commitment to the well-being of our community.”The launch of the SNG plant underscores Hussain Developer Bahawal Pur’s dedication to innovation, sustainability, and the welfare of its residents. As the first step in a series of transformative advancements, Hussain Developer Bahawal Pur reaffirms its position as an industry leader in addressing critical energy needs and enhancing the quality of life for its residents.",

    title:
      "Hussain developer DISTRIBUTES 250 RATION BAGS AMONG RICKSHAW DRIVERS OF KARACHI",
    date: "2 Oct 2023",
    desc: "Press Release Hussain Developer distributes 250 ration bags among rickshaw drivers of Bahawal Pur...",
  },
  {
    id: "3",
    img: PressImg,
    detail:
      "Hussain Developer – Hussain Developer Bahawal Pur is the only private real estate sector that has introduced the Synthetic Natural Gas (SNG) plant, marking a significant leap forward in sustainable gas supply solutions in the face of energy crisis. The pioneering SNG plant, with a capacity of 70 MMBTU/HR, is set to provide uninterrupted gas supply to thousands of households scaling up to accommodate the needs of up to 10,000 houses in the initial phase.Amid the prevailing challenges of gas shortages faced by Pakistan, Hussain Developer Bahawal Pur’s SNG plant takes center stage as a beacon of innovation and reliability in gas distribution. The United States-originated SNG plant is strategically interconnected with an extensive gas network spanning approximately 650 km across Hussain Developer’s vicinity. This strategic integration ensures the seamless delivery of safe, reliable, and efficient SNG supply to the residents of Hussain Developer Bahawal Pur.Adhering meticulously to international standards and regulations, the SNG plant demonstrates full compliance with the regulations set forth by the Oil and Gas Regulatory Authority (OGRA), National Fire Protection Association (NFPA), American Petroleum Institute (API), American Gas Association (AGA), American Society for Testing and Materials (ASTM), and American Society of Mechanical Engineers (ASME). These stringent measures underscore Hussain Developer Bahawal Pur’s unwavering commitment to maintaining the highest standards of safety, quality, and operational excellence.    “This achievement marks the first milestone in our journey to provide reliable gas supply to Hussain Developer Bahawal Pur,” stated Spokesperson of Hussain Developer Bahawal Pur. “We are dedicated to pioneering solutions that alleviate the challenges posed by gas shortages in Pakistan. This SNG plant showcases our dedication to sustainable infrastructure development and serves as a testament to our commitment to the well-being of our community.”The launch of the SNG plant underscores Hussain Developer Bahawal Pur’s dedication to innovation, sustainability, and the welfare of its residents. As the first step in a series of transformative advancements, Hussain Developer Bahawal Pur reaffirms its position as an industry leader in addressing critical energy needs and enhancing the quality of life for its residents.",

    title:
      "Hussain developer DISTRIBUTES 250 RATION BAGS AMONG RICKSHAW DRIVERS OF KARACHI",
    date: "22 Sep 2023",
    desc: "Press Release Hussain Developer distributes 250 ration bags among rickshaw drivers of Bahawal Pur...",
  },
  {
    id: "4",
    img: PressImg2,
    detail:
      "Hussain Developer – Hussain Developer Bahawal Pur is the only private real estate sector that has introduced the Synthetic Natural Gas (SNG) plant, marking a significant leap forward in sustainable gas supply solutions in the face of energy crisis. The pioneering SNG plant, with a capacity of 70 MMBTU/HR, is set to provide uninterrupted gas supply to thousands of households scaling up to accommodate the needs of up to 10,000 houses in the initial phase.Amid the prevailing challenges of gas shortages faced by Pakistan, Hussain Developer Bahawal Pur’s SNG plant takes center stage as a beacon of innovation and reliability in gas distribution. The United States-originated SNG plant is strategically interconnected with an extensive gas network spanning approximately 650 km across Hussain Developer’s vicinity. This strategic integration ensures the seamless delivery of safe, reliable, and efficient SNG supply to the residents of Hussain Developer Bahawal Pur.Adhering meticulously to international standards and regulations, the SNG plant demonstrates full compliance with the regulations set forth by the Oil and Gas Regulatory Authority (OGRA), National Fire Protection Association (NFPA), American Petroleum Institute (API), American Gas Association (AGA), American Society for Testing and Materials (ASTM), and American Society of Mechanical Engineers (ASME). These stringent measures underscore Hussain Developer Bahawal Pur’s unwavering commitment to maintaining the highest standards of safety, quality, and operational excellence.    “This achievement marks the first milestone in our journey to provide reliable gas supply to Hussain Developer Bahawal Pur,” stated Spokesperson of Hussain Developer Bahawal Pur. “We are dedicated to pioneering solutions that alleviate the challenges posed by gas shortages in Pakistan. This SNG plant showcases our dedication to sustainable infrastructure development and serves as a testament to our commitment to the well-being of our community.”The launch of the SNG plant underscores Hussain Developer Bahawal Pur’s dedication to innovation, sustainability, and the welfare of its residents. As the first step in a series of transformative advancements, Hussain Developer Bahawal Pur reaffirms its position as an industry leader in addressing critical energy needs and enhancing the quality of life for its residents.",

    title:
      "Hussain developer DISTRIBUTES 250 RATION BAGS AMONG RICKSHAW DRIVERS OF KARACHI",
    date: "2 Oct 2023",
    desc: "Press Release Hussain Developer distributes 250 ration bags among rickshaw drivers of Bahawal Pur...",
  },
  {
    id: "5",
    img: PressImg,
    detail:
      "Hussain Developer – Hussain Developer Bahawal Pur is the only private real estate sector that has introduced the Synthetic Natural Gas (SNG) plant, marking a significant leap forward in sustainable gas supply solutions in the face of energy crisis. The pioneering SNG plant, with a capacity of 70 MMBTU/HR, is set to provide uninterrupted gas supply to thousands of households scaling up to accommodate the needs of up to 10,000 houses in the initial phase.Amid the prevailing challenges of gas shortages faced by Pakistan, Hussain Developer Bahawal Pur’s SNG plant takes center stage as a beacon of innovation and reliability in gas distribution. The United States-originated SNG plant is strategically interconnected with an extensive gas network spanning approximately 650 km across Hussain Developer’s vicinity. This strategic integration ensures the seamless delivery of safe, reliable, and efficient SNG supply to the residents of Hussain Developer Bahawal Pur.Adhering meticulously to international standards and regulations, the SNG plant demonstrates full compliance with the regulations set forth by the Oil and Gas Regulatory Authority (OGRA), National Fire Protection Association (NFPA), American Petroleum Institute (API), American Gas Association (AGA), American Society for Testing and Materials (ASTM), and American Society of Mechanical Engineers (ASME). These stringent measures underscore Hussain Developer Bahawal Pur’s unwavering commitment to maintaining the highest standards of safety, quality, and operational excellence.    “This achievement marks the first milestone in our journey to provide reliable gas supply to Hussain Developer Bahawal Pur,” stated Spokesperson of Hussain Developer Bahawal Pur. “We are dedicated to pioneering solutions that alleviate the challenges posed by gas shortages in Pakistan. This SNG plant showcases our dedication to sustainable infrastructure development and serves as a testament to our commitment to the well-being of our community.”The launch of the SNG plant underscores Hussain Developer Bahawal Pur’s dedication to innovation, sustainability, and the welfare of its residents. As the first step in a series of transformative advancements, Hussain Developer Bahawal Pur reaffirms its position as an industry leader in addressing critical energy needs and enhancing the quality of life for its residents.",

    title:
      "Hussain developer DISTRIBUTES 250 RATION BAGS AMONG RICKSHAW DRIVERS OF KARACHI",
    date: "2 Oct 2023",
    desc: "Press Release Hussain Developer distributes 250 ration bags among rickshaw drivers of Bahawal Pur...",
  },
];
